import React from "react";
import dynamic from "next/dynamic";
import styles from "./Apps.module.scss";

const AppGallery = dynamic(() => import("assets/icons/apps/app-gallery.svg"));
const AppStore = dynamic(() => import("assets/icons/apps/app-store.svg"));
const GooglePlay = dynamic(() => import("assets/icons/apps/google-play.svg"));

const Apps: React.FC = () => (
  <div className={styles.footer500Apps}>
    <p className={styles.footer500AppsTitle} />

    <div className={styles.footer500AppsGrid}>
      <a
        className={styles.footer500AppsItem}
        aria-label="Google Play"
        href="https://play.google.com/store/apps/details?id=ru.zdravcity.app&hl=ru"
      >
        <GooglePlay />
      </a>

      <a
        className={styles.footer500AppsItem}
        aria-label="App Store"
        href="https://apps.apple.com/ru/app/zdravsiti/id1119115786"
      >
        <AppStore />
      </a>

      <a
        className={styles.footer500AppsItem}
        aria-label="App Gallery"
        href="https://appgallery.huawei.com/#/app/C102626077"
      >
        <AppGallery />
      </a>
    </div>

    <div className={styles.footer500AppsQrContainer}>
      <img src="/img/footer/qr-app.png" alt="APP QR" />

      <div className={styles.footer500AppsQrInfo}>
        Наведите камеру на <span>QR-код</span>, чтобы скачать
        <img src="/img/footer/qr-arrow.svg" alt="QR arrow" />
      </div>
    </div>
  </div>
);

export default Apps;
